import { useEffect } from "react";

/**
 * Escape closes it.
 *
 * Every dialog in the app should. A hand-rolled overlay does not get this for
 * free the way the Radix primitives do — the generate dialog on the Documents
 * screen did not, and the only way out was the Cancel button, which is the kind
 * of thing people notice as the app feeling wrong long before they report it.
 *
 * Listens on the document with capture, so it works whatever has focus,
 * including nothing.
 */
export function useEscape(active, onEscape) {
  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => {
      if (e.key !== "Escape") return;
      e.stopPropagation();      // the topmost listener wins: one Escape, one dialog
      onEscape?.();
    };
    document.addEventListener("keydown", onKey, true);
    return () => document.removeEventListener("keydown", onKey, true);
  }, [active, onEscape]);
}

export default useEscape;
